jQuery(document).ready(function ($) {
  var stickyscroll = 0;
  var timeout = ( function(){ var timers = {}; return function( callback, ms, x_id ){ if ( !x_id ){ x_id = ''; } if ( timers[x_id] ){ clearTimeout( timers[x_id] ); } timers[x_id] = setTimeout( callback, ms ); }; })()
  if( $('.sticky-bar').length ) {
    stickyscroll = $(".sticky-bar").offset().top;
  }  
  $('.faq-q').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {
    });
  });
  $( 'a' ).click( function(e){
    if( this.hash && $( this.hash ).offset() ){
      e.preventDefault();
      window.scrollTo({
        top: $( this.hash ).offset().top, 
        behavior: 'smooth'
      });
    }      
  });
  $('.click-here').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {});
  });
  $('.menu-icon i').click(function () {
    $(this).toggleClass('active');
    $('.toggle-menu-wrap').slideToggle("slow", function () {});
  });
  if ( $('#owl-carousel2').length ) {
    $("#owl-carousel2").owlCarousel({
      loop: true,
      items: 1,
      nav:true,
      slideSpeed: 2000,
      autoplay: true,
      thumbs: true,
      dots: false,
      thumbImage: true,
      thumbContainerClass: "owl-thumbs",
      thumbItemClass: "owl-thumb-item"
    });
  }
  if ( $('.lp-owlCarousel').length ) {
    $('.lp-owlCarousel').owlCarousel({
        loop: false,
        nav: false,
        dots: false,
        margin: 24,
        autoHeight: true,
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
                nav: true,
                dots: false
            },
            901: {
                items: 4,
                nav: true,
                dots: false
            }
        }
    });
  }
  if ( window.innerWidth > 1023 ) {
    if ( $( window ).scrollTop() > stickyscroll && $('.sticky-bar').length ) {
      $(".sticky-bar").addClass('active');
    }
    if ( $( window ).scrollTop() < stickyscroll && $('.sticky-bar').length ) {
       $(".sticky-bar").removeClass('active');
    }
  }
  $( window ).scroll(function(){
    timeout( function(){
      if ( $( window ).scrollTop() > 49 && $('.header-v2').length ) {
        $('.header-v2').addClass('active');
        $('.header-overlay').addClass('active');
      }
      if ( $( window ).scrollTop() < 50 && $('.header-v2').length ) {
        $('.header-v2').removeClass('active');
        $('.header-overlay').removeClass('active');
      }
      if ( window.innerWidth > 1023 ) {
        if ( $( window ).scrollTop() > stickyscroll && $('.sticky-bar').length ) {
          $(".sticky-bar").addClass('active');
        }
        if ( $( window ).scrollTop() < stickyscroll && $('.sticky-bar').length ) {
           $(".sticky-bar").removeClass('active');
        } 
      }
    }, 10 );
  });
  $('.yt').click(function(){
    autoPlayVideo($(this).attr('ytid'));
  });
  function autoPlayVideo(vcode){
    "use strict";
    $('.yt').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+vcode+'?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe>');
  }
  loop();
  mslider();
  $( window ).resize( function(){
      timeout( function(){
        loop();
        mslider();
      }, 200 );
  });
  $(window).bind('load',function() {
    if ( $('#fi-marquee').length && window.innerWidth < 768 ) {
      for (let i = 0; i < 3; i++) {
        $('#fi-marquee').append($('#fi-marquee').html());
      }
    }
    if ( $('#carousel').length ) {
      $('#carousel').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 210,
        itemMargin: 5,
        asNavFor: '#slider'
      });
    }
    if ( $('#slider').length ) {
      $('#slider').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#carousel"
      });
    }
  });
  function loop(){
    if($('.loop').length && window.innerWidth < 1024){
      $('.loop').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav: true,
        dots: false
      });
    }else{
      if($('.loop').length){
        $('.loop').owlCarousel('destroy');
      }
    }
  }
  function mslider(){
    if($('.m-slider').length && window.innerWidth < 1024){
      $('.m-slider').addClass( 'owl-carousel owl-theme' );
      $('.m-slider').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav: true,
        dots: false
      });
    }else{
      if($('.m-slider').length){
        $('.m-slider').owlCarousel('destroy');
        $('.m-slider').removeClass( 'owl-carousel owl-theme' );
      }
    }
  }
});